export const setMinimalPromiseTime: {
  <Type>(arg: Type | Promise<Type>, minimalTime?: number): Promise<Type>;
} = async (promise, minimalTime = 250) => {
  const response = await Promise.all([
    promise,
    new Promise((resolve) => setTimeout(resolve, minimalTime)),
  ]);
  return response[0];
};
